import React from "react";
import { Link } from "react-router-dom";

function LandingPage() {
  return (
    <div
      className="bg-cover bg-center h-screen flex flex-col justify-center items-center"
      style={{ backgroundImage: "url('/images/crypto-bg.jpg')" }}
    >
      <div className="backdrop-blur-md bg-black bg-opacity-3 p-8 rounded-2xl shadow-lg text-center">
        <h1 className="text-5xl font-bold text-gold mb-4">Welcome to iTrader</h1>
        <p className="text-white text-lg mb-6">AI Powered, Institution Grade Trading Edge.</p>
        <div className="space-x-4">
          <Link to="/login" className="bg-gold text-black px-6 py-2 rounded-lg font-semibold hover:opacity-90">Login</Link>
          <Link to="/register" className="bg-transparent border-2 border-gold text-gold px-6 py-2 rounded-lg font-semibold hover:bg-gold hover:text-black">Register</Link>
        </div>
      </div>
    </div>
  );
}

export default LandingPage;
